import store from 'dashboard/store';
import PatientOverviewSmokingGoalSetting from 'dashboard/templates/views/Patient/SC/PatientOverviewSmokingGoalSetting';

export default {
    path: 'goal-setting',
    name: 'PatientRecordSmokingGoalSetting',
    component: PatientOverviewSmokingGoalSetting,
    meta: {
        // title: 'Patient Record - Smoke-free living - Goal Setting',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.smokeFreeLivingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        // title: 'Smoke-free living - Goal Setting',
        title: t => `${t('screens.smokeFreeLivingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        loggedInOnly: true,
        inSDMSessionOnly: true,
    },
    async beforeEnter(to, from, next) {
        const currentPatientId = from.params?.patientId;
        const newPatientId = to.params?.patientId;

        // Update user if back is used as everything stays cached in computed
        if ((currentPatientId === undefined && newPatientId) ||
            currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
        ) {
          await Promise.all([
            store.dispatch('patientSummary/get', newPatientId, {root: true}),
          ]);

          next();
        } else {
          next();
        }
      },
};
